import React from "react";
import { WifiOff } from "lucide-react";

/**
 * Offline state for the PWA offline-shell contract:
 * "You are offline — reconnect to continue" with cached header/logo.
 */
export function OfflineState() {
  return (
    <div className="ds-state">
      <div className="ds-state-icon"><WifiOff size={28} /></div>
      <div className="ds-state-title">You are offline</div>
      <div className="ds-state-hint">Reconnect to continue · cached header + logo still shown.</div>
    </div>
  );
}
